import { conversationAIRouteNames, conversationRouteNames, locationSettingsRouteNames } from "@/routes/constants/location";
export const DEFAULT_MARKUP = 1;
export const enum PRODUCT_TYPE {
  PHONE = 'phone',
  EMAIL = 'email',
  WHATSAPP = 'whatsapp',
  PRODUCT_REBILLING = 'product_rebilling'
}
export const enum SUBSCRIPTION_STATUS {
  ACTIVE = 'active',
  TRIALING = 'trialing',
  PAST_DUE = 'past_due',
  UNPAID = 'unpaid',
  CANCELLED = 'canceled',
  INCOMPLETE = 'incomplete',
  INCOMPLETE_EXPIRED = 'incomplete_expired'
}

export const INACTIVE_STATUS = ['past_due', 'unpaid', 'canceled', 'incomplete', 'incomplete_expired'];

export const LC_EMAIL_BASEPRICE = 0.000675;

export const enum SUSPEND_REASONS {
  INVALID_STATE = 'subscription created with invalid status',
  SUBSCRIPTION_SYNC = 'subscription sync'
}

export const enum LC_TYPE {
  LC_PHONE = 'lc_phone',
  LC_EMAIL = 'lc_email'
}

export const enum LCEmailState {
  ENABLED = 'enabled',
  NOT_ENABLED = 'not_enabled'
}

export const SAAS_ASSETS_BASE_URL = "https://storage.googleapis.com/preview-production-assets/saas/img";
export const IMAGE_AI_BASE_PRICE = 0.06;
export const WORKFLOW_AI_GPT_3_PRICE = 0.015;
export const VOICE_AI_BASE_PRICE = 0.13;
export const CONTENT_AI_LABEL = "Image";
export const WORKFLOW_AI_LABEL = "GPT 3.5 execution";
export const CONVERSATION_AI_LABEL = "Minute voice call";
export const AUTO_COMPLETE_ADDRESS_BASE_PRICE = 0.00525;
export const WORKFLOW_AI_GPT_4O_MINI_INPUT_PRICE = 0.60;
export const WORKFLOW_AI_GPT_4O_MINI_OUTPUT_PRICE = 2.40;


export const CUSTOM_AGENCIES_PERMISSIONS = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'beta' ? {
  'tudfVdx3VWoVLRby2OjA': {
    tabs: ['My Staff', 'Phone Numbers', 'Email Services', 'Conversations', 'Conversation Providers', 'Conversation AI', 'common.sidebar.conversations', 'common.sidebar.myStaff', 'common.sidebar.phoneNumbers', 'common.sidebar.emailServices', 'common.sidebar.conversationProviders'],
    routes: [locationSettingsRouteNames.staff.default, locationSettingsRouteNames.staff.team, locationSettingsRouteNames.staff.teams, locationSettingsRouteNames.phoneNumber, locationSettingsRouteNames.phoneSystem, locationSettingsRouteNames.emailService.default, conversationRouteNames.triggerLinksConversationsV2, 'conversations', locationSettingsRouteNames.conversationProviders, conversationAIRouteNames.conversationAISettings],
    userType: ['account']
  }
} : {
  'Fk0xgtDJDlSn6N5wj8oZ': {
    tabs: ['My Staff', 'Phone Numbers', 'Email Services', 'Conversations', 'Conversation Providers', 'Conversation AI', 'common.sidebar.conversations', 'common.sidebar.myStaff', 'common.sidebar.phoneNumbers', 'common.sidebar.emailServices', 'common.sidebar.conversationProviders'],
    routes: [locationSettingsRouteNames.staff.default, locationSettingsRouteNames.staff.team, locationSettingsRouteNames.staff.teams, locationSettingsRouteNames.phoneNumber, locationSettingsRouteNames.phoneSystem, locationSettingsRouteNames.emailService.default, conversationRouteNames.triggerLinksConversationsV2, 'conversations', locationSettingsRouteNames.conversationProviders, conversationAIRouteNames.conversationAISettings],
    userType: ['account']
  }
}

export const TEST_AGENCIES = ['YuTUZlUtrwBtvmgByZDW', 'Ydk7Yx1VsHhacT39iE4Z', '5DP4iH6HLkQsiKESj6rh', '4jmzV68Y7eDq2tFXlpva', 'w6dADQRzRL23SiVdK5VL'];

import { i18n } from '@/localization'

export const SUSPENDED_INFO_DETAILS = {
  temporarily_suspended: {
    heading: i18n.global.t('suspension.temporarily.heading'),
    description: i18n.global.t('suspension.temporarily.description')
  },
  suspended: {
    heading: i18n.global.t('suspension.suspended.heading'),
    description: i18n.global.t('suspension.suspended.description')
  }
}

export const SUB_ACCOUNT_RESTRICTED_STATUS = ['APPROVAL_PENDING', 'DECLINED']


export const DEFAULT_PERMISSIONS = {
  conversations_enabled: true,
  phone_call_enabled: true,
  adwords_reporting_enabled: true,
  agent_reporting_enabled: true,
  attributions_reporting_enabled: true,
  facebook_ads_reporting_enabled: true,
  appointments_enabled: true,
  contacts_enabled: true,
  dashboard_stats_enabled: true,
  bulk_requests_enabled: true,
  email_builder_enabled: true,
  marketing_enabled: true,
  facebook_messenger_enabled: true,
  funnels_enabled: true,
  gmb_call_tracking_enabled: true,
  gmb_messaging_enabled: true,
  membership_enabled: true,
  opportunities_enabled: true,
  reviews_enabled: true,
  text_to_pay_enabled: true,
  web_chat_enabled: true,
  websites_enabled: true,
  workflows_enabled: true,
  forms_enabled: true,
  quizzes_enabled: true,
  quiz_enabled: true,
  surveys_enabled: true,
  trigger_links_enabled: true,
  sms_email_templates_enabled: true,
  html_builder_enabled: true,
  triggers_enabled: true,
  campaigns_enabled: true,
  social_planner: true,
  invoice_enabled: true,
  blogging_enabled: true,
  affiliate_manager_enabled: true,
  proposals_enabled: true,
  communities_enabled: true,
  certificates_enabled: true,
  bot_service_enabled: true,
  media_storage_enabled: true,
  qr_codes_enabled: true,
  settings_enabled: true,
  tags_enabled: true,
  gokollab_enabled: true,
  ad_manager_enabled: true,
  launchpad_enabled: true
}
